import React from 'react'

// Standard outer wrapper for homepage rails.
// Gives every section the same horizontal padding and max-width,
// and a consistent vertical rhythm.
//
// Optional `card` prop wraps content in a subtle bordered card
// (useful for deal rails that want a soft tinted background).

const HomeSection = ({
    id,
    card = false,
    tone, // 'accent' | 'brand' | 'danger' | undefined
    className = '',
    children,
}) => {
    const toneCard = {
        accent: 'border-accent-100 bg-gradient-to-br from-white via-white to-accent-50/60',
        brand:  'border-brand-100  bg-gradient-to-br from-white via-white to-brand-50/60',
        danger: 'border-danger-100 bg-gradient-to-br from-white via-white to-danger-50/60',
    }
    return (
        <section
            id={id}
            className={`w-full max-w-marketplace mx-auto px-4 sm:px-4 md-lg:px-5 md:px-5 lg:px-8 py-8 sm:py-6 ${className}`}
        >
            {card ? (
                <div className={`rounded-card border shadow-card p-5 sm:p-4 ${toneCard[tone] || 'border-slate-200 bg-white'}`}>
                    {children}
                </div>
            ) : (
                children
            )}
        </section>
    )
}

export default HomeSection
